import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import format from 'date-fns/format';
import Pagination from '../../../components/Pagination/Pagination';
import CustomTable from '../../../components/Table/Table';
import GridItem from '../../../components/Grid/GridItem';
import Snackbar from '../../../components/Snackbar/Snackbar';
import Typography from '../../../components/Typography/CustomTypography';
import styles from '../../../assets/jss/pages/productManagementPageStyle';
import DialogEditSeminar from './DialogEditSeminar';
import DialogDetailSeminar from './DialogDetailSeminar';
import Button from '../../../components/Button/CustomButton';
import ProgessDialog from '../../../components/Dialog/ProgessDialog';
import Loader from '../../../components/Loader/Loader';
import AlertDialog from '../../../components/Dialog/AlertDialog';

import { convertDuration } from '../../../utils/dateUtils';
import { SEMINAR_STATUS_CHECK } from '../../../common/Constants';

const useStyles = makeStyles(styles);

const ActionRow = ({
    onEdit, onDelete, isDisableEdit, ...rest
}) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
        <Button onClick={onEdit} color="success" disabled={isDisableEdit} {...rest} style={{ fontSize: '14px' }}>編集</Button>
        &nbsp;
        <Button onClick={onDelete} color="danger" {...rest} style={{ fontSize: '14px' }}>削除</Button>
    </Box>
);

const ListSeminar = (props) => {
    const {
        fetchListSeminar,
        listSeminar,
        seminars,
        errors,
        getDetailCompany,
        detailCompany,
        eventInfo,
        seminarDetail,
        getDetailSeminar,
        clearDetailComopany,
        updateSeminar,
        updateSeminarSuccess,
        getInformationRoom,
        room,
        isFetchingUpdate,
        clearSeminar,
        clearUpdateSeminar,
        percent,
        token,
        isLoading,
        deleteSeminar,
        deleteSuccessSeminar,
        clearDeleteSeminar,
        detailSeminarErrors,
        clearDetailSeminar,
        deleteErrorSeminar,
    } = props;
    const classes = useStyles();
    const intl = useIntl();
    const routeParams = useParams();
    const [viewerList, setViewerList] = useState([]);
    const [currentPage, setCurrentPage] = useState();
    const [isOpenDialogDetail, setIsOpenDialogDetail] = useState(false);
    const [isOpenDialogEdit, setIsOpenDialogEdit] = useState(false);
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [detailSeminarState, setDetailSeminarState] = useState({});
    const [roomInfo, setRoomInfo] = useState({});
    const [dialogConfirm, setDialogConfirm] = useState({
        isOpen: false,
        handleClose: () => {},
        handleSubmit: () => {},
        contents: '',
    });

    useEffect(() => {
        getDetailCompany({
            event_name: routeParams.shortName,
            company_id: routeParams.idCompany,
        });
        fetchListSeminar({ company_id: routeParams.idCompany, page: 1, page_size: 20 });
        return () => {
            clearDetailComopany();
            clearSeminar();
        };
    }, [routeParams]);

    useEffect(() => {
        if (updateSeminarSuccess) {
            setIsOpenDialogEdit(false);
            fetchListSeminar({ company_id: routeParams.idCompany, page: 1, page_size: 20 });
            setSnackbar({ isOpen: true, type: 'success', message: <FormattedMessage id="apiSuccess.default" /> });
            setDetailSeminarState({});
        }
    }, [updateSeminarSuccess]);

    useEffect(() => {
        if (deleteSuccessSeminar) {
            setDialogConfirm({
                ...dialogConfirm,
                isOpen: false,
            });
            fetchListSeminar({ company_id: routeParams.idCompany, page: 1, page_size: 20 });
            setSnackbar({ isOpen: true, type: 'success', message: <FormattedMessage id="apiSuccess.default" /> });
            setDetailSeminarState({});
            clearDeleteSeminar();
        }
    }, [deleteSuccessSeminar]);

    useEffect(() => {
        if (!_.isEmpty(deleteErrorSeminar)) {
            setDialogConfirm({
                ...dialogConfirm,
                isOpen: false,
            });
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: deleteErrorSeminar?.message?.message || deleteErrorSeminar.non_field_errors?.message,
            });
            fetchListSeminar({ company_id: routeParams.idCompany, page: 1, page_size: 20 });
            setDetailSeminarState({});
            clearDeleteSeminar();
        }
    }, [deleteErrorSeminar]);

    useEffect(() => {
        setDetailSeminarState({ ...detailSeminarState, ...seminarDetail });
    }, [seminarDetail]);

    useEffect(() => {
        if (room) {
            setRoomInfo({ ...room });
        } else {
            setRoomInfo({});
        }
    }, [room]);

    useEffect(() => {
        if (errors && errors.code) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: errors?.message?.message || errors.non_field_errors?.message,
            });
        }
    }, [errors]);

    useEffect(() => {
        let tableData = [];
        if (listSeminar && listSeminar.length > 0) {
            tableData = listSeminar.map((seminar) => {
                const status = getSeminarStatus(seminar.is_paused, seminar.is_deleted);

                return [
                    format(new Date(seminar.date), 'yyyy/MM/dd'),
                    `${seminar.stime}~${seminar.etime}`,
                    seminar.speaker,
                    seminar.speaker_img && <img src={seminar.speaker_img.concat('?=', new Date().getTime().toString())} alt="" style={{ width: '50px', height: '50px' }} />,
                    seminar.title,
                    seminar.content,
                    convertDuration(
                        seminar.media_duration,
                        intl.formatMessage({ id: 'common.hour' }),
                        intl.formatMessage({ id: 'common.minute' }),
                        intl.formatMessage({ id: 'common.second' }),
                    ),
                    status.MSG,
                    <ActionRow
                        onEdit={(e) => handleEditInTable(e, seminar.id)}
                        onDelete={(e) => handleDeleteInTable(e, seminar.id, seminar.is_in_order_waiting)}
                        size="sm"
                        isDisableEdit={status.CODE !== SEMINAR_STATUS_CHECK.NORMAL.CODE}
                    />,
                ];
            });
        }
        setViewerList(tableData);
    }, [listSeminar]);

    const getSeminarStatus = (isPaused, isDeleted) => {
        if (isPaused && isDeleted) {
            return SEMINAR_STATUS_CHECK.DELETED;
        }
        if (!isPaused && !isDeleted) {
            return SEMINAR_STATUS_CHECK.NORMAL;
        }
        if (isDeleted) {
            return SEMINAR_STATUS_CHECK.DELETED;
        }
        return SEMINAR_STATUS_CHECK.PAUSED;
    };

    const handleEditInTable = (e, id) => {
        e.stopPropagation();
        setIsOpenDialogEdit(true);
        getDetailSeminar({
            company_id: routeParams.idCompany,
            seminar_id: id,
        });
    };
    const handleDeleteInTable = (e, id, isWaiting) => {
        e.stopPropagation();
        setDialogConfirm({
            isOpen: true,
            handleClose: () => { setDialogConfirm({ ...dialogConfirm, isOpen: false }); },
            handleSubmit: () => {
                deleteSeminar({
                    company_id: routeParams.idCompany,
                    seminar_id: id,
                });
            },
            contents: !isWaiting ? '削除しますか？' : (
                <>
                    <p>このセミナーは登録ユーザーがいます。そして、承認されるのを待っています。</p>
                    <p>セミナーを削除した場合、承認できなくなります。</p>
                </>
            ),
        });
    };
    const handleGetRoomInfo = (dateSeminar, seminarId) => {
        const date = format(new Date(dateSeminar), 'yyyy-MM-dd');
        getInformationRoom({
            shortName: routeParams.shortName,
            date,
            seminar_id: seminarId,
        });
    };

    const handleEditInDetail = (id) => {
        setIsOpenDialogDetail(false);
        setIsOpenDialogEdit(true);
        getDetailSeminar({
            company_id: routeParams.idCompany,
            seminar_id: id,
        });
    };

    const handleSearchWithPage = (page) => {
        setCurrentPage(page);
        if (fetchListSeminar) {
            fetchListSeminar({
                company_id: routeParams.idCompany,
                page_size: 20,
                page,
            });
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const handleShowDialogDetail = (index) => {
        // Get seminar status, check if is disabled
        if (viewerList[index][7] === SEMINAR_STATUS_CHECK.DELETED.MSG || viewerList[index][7] === SEMINAR_STATUS_CHECK.PAUSED.MSG) {
            return;
        }

        setIsOpenDialogDetail(true);
        if (listSeminar[index] && listSeminar[index].id) {
            getDetailSeminar({
                company_id: routeParams.idCompany,
                seminar_id: listSeminar[index].id,
            });
        }
    };

    const handleCloseDialogEdit = () => {
        setDetailSeminarState({});
        setIsOpenDialogEdit(false);
        clearUpdateSeminar();
    };
    const handleCloseDialogDetail = () => {
        setDetailSeminarState({});
        setIsOpenDialogDetail(false);
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <div className={classes.wrapper}>
                <GridItem xs={12}>
                    <Typography bold variant="h4" color="info" style={{ textAlign: 'center' }}>
                        {detailCompany.fullName}
                    </Typography>
                    <CustomTable
                        onClick={(index) => handleShowDialogDetail(index)}
                        tableHead={['開催日', '時間', '講演者', '講演者写真', '講演名', '講演内容', '再生時間', '状況', 'アクション']}
                        tableHeadWidth={['10%', '10%', '10%', '7.5%', '10%', '27.5%', '7.5%', '7.5%', '10%']}
                        tableData={viewerList}
                        tableFooter={(
                            <Box display="flex" justifyContent="center">
                                <Pagination
                                    page={seminars.page}
                                    total={seminars.total_page}
                                    onChange={(page) => handleSearchWithPage(page)}
                                />
                            </Box>
                        )}
                    />
                    <DialogEditSeminar
                        isOpen={isOpenDialogEdit}
                        rooms={roomInfo}
                        eventInfo={eventInfo}
                        getRoomInfo={handleGetRoomInfo}
                        handleClose={handleCloseDialogEdit}
                        detailSeminar={detailSeminarState}
                        companyId={routeParams.idCompany}
                        handleEditSeminar={(value) => updateSeminar(value)}
                        detailSeminarErrors={detailSeminarErrors}
                        clearDetailSeminar={clearDetailSeminar}
                        fetchListSeminar={() => fetchListSeminar({ company_id: routeParams.idCompany, page: 1, page_size: 20 })}
                    />
                    <DialogDetailSeminar
                        isOpen={isOpenDialogDetail}
                        handleClose={handleCloseDialogDetail}
                        detailSeminar={detailSeminarState}
                        handleEditInDetail={handleEditInDetail}
                        updateSeminarSuccess={updateSeminarSuccess}
                        percent={percent}
                        token={token}
                        eventInfo={eventInfo}
                        detailSeminarErrors={detailSeminarErrors}
                        clearDetailSeminar={clearDetailSeminar}
                        fetchListSeminar={() => fetchListSeminar({ company_id: routeParams.idCompany, page: 1, page_size: 20 })}
                    />
                </GridItem>
            </div>
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
                autoHideDuration={3000}
            />
            <AlertDialog
                handleOpen={dialogConfirm.isOpen}
                handleClose={dialogConfirm.handleClose}
                handleSubmit={dialogConfirm.handleSubmit}
                contents={dialogConfirm.contents}
            />
            <ProgessDialog isOpen={isFetchingUpdate} percent={percent} />
        </>
    );
};

ListSeminar.defaultProps = {
    listSeminar: [],
    seminars: {},
    room: {},
    errors: {},
    eventInfo: {},
    detailCompany: {},
    seminarDetail: {},
    updateSeminarSuccess: false,
    isFetchingUpdate: true,
    percent: 0,
    token: '',
    detailSeminarErrors: {},
    clearDetailSeminar: () => {},
    deleteErrorSeminar: () => {},
};

ListSeminar.propTypes = {
    fetchListSeminar: PropTypes.func.isRequired,
    getDetailCompany: PropTypes.func.isRequired,
    getInformationRoom: PropTypes.func.isRequired,
    clearSeminar: PropTypes.func.isRequired,
    clearUpdateSeminar: PropTypes.func.isRequired,
    clearDetailComopany: PropTypes.func.isRequired,
    getDetailSeminar: PropTypes.func.isRequired,
    updateSeminar: PropTypes.func.isRequired,
    updateSeminarSuccess: PropTypes.bool,
    listSeminar: PropTypes.oneOfType([() => null, PropTypes.array]),
    seminars: PropTypes.oneOfType([() => null, PropTypes.object]),
    room: PropTypes.oneOfType([() => null, PropTypes.object]),
    seminarDetail: PropTypes.oneOfType([() => null, PropTypes.object]),
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    detailCompany: PropTypes.oneOfType([() => null, PropTypes.object]),
    percent: PropTypes.number,
    isFetchingUpdate: PropTypes.bool,
    token: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    deleteSuccessSeminar: PropTypes.bool.isRequired,
    deleteSeminar: PropTypes.func.isRequired,
    clearDeleteSeminar: PropTypes.func.isRequired,
    detailSeminarErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearDetailSeminar: PropTypes.func,
    deleteErrorSeminar: PropTypes.oneOfType([() => null, PropTypes.object]),
};

ActionRow.propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isDisableEdit: PropTypes.func.isRequired,
};

export default ListSeminar;
